import { GATE_STATUS, KNOWN_GATE_STATES } from 'utils/constants'

/** klucz tłumaczenia (namespace entrance) dla stanu bramy */
export const getGateStatusLabel = (status?: string) => {
  switch (status) {
    case GATE_STATUS.opened: return 'gateOpen'
    case GATE_STATUS.opening: return 'gateOpening'
    case GATE_STATUS.closing: return 'gateClosing'
    case GATE_STATUS.stopped: return 'gateStopped'
    case GATE_STATUS.malfunction: return 'gateMalfunction'
    case GATE_STATUS.closed:
    case undefined: return 'gateClosed'
    default: return KNOWN_GATE_STATES.includes(status) ? 'gateClosed' : 'gateUnknown'
  }
}
